import React from 'react'

import { Block, Section } from '../Layout'
import { BoxHeader } from '../BoxHeader'
import LoadingLine from './Line'

const Layout = () => (
  <Block>
    <BoxHeader
      breadcrumbItems={[
        {
          type: 'title',
          text: <LoadingLine />
        }
      ]}
    />
    <Section>
      <LoadingLine />
    </Section>
  </Block>
)

export default Layout
